var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 35,
    viewBox: "0 0 170 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            @font-face {\n              font-family: Monorale;\n              font-weight: 400;\n              font-style: normal;\n              src: url('/fonts/Monorale-Regular.woff') format('woff');\n              font-display: fallback;\n            }\n            @font-face {\n                font-family: Monorale;\n                font-weight: 500;\n                font-style: normal;\n                src: url('/fonts/Monorale-Medium.woff') format('woff');\n                font-display: fallback;\n            }\n            @font-face {\n                font-family: Monorale;\n                font-weight: 700;\n                font-style: normal;\n                src: url('/fonts/Monorale-Bold.woff') format('woff');\n                font-display: fallback;\n            }\n        "), /*#__PURE__*/React.createElement("mask", {
    id: "logo_mask",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    id: "overlay",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 26,
    fontWeight: "bold",
    letterSpacing: 2.167
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.604,
    y: 27
  }, "S"))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    mask: "url(#logo_mask)",
    width: 35,
    height: 35,
    rx: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 1.333,
    transform: "translate(52 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "SURVEILLANCE")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 10,
    letterSpacing: 0.833,
    transform: "translate(52 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "DASHBOARD")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginScreen);
export default __webpack_public_path__ + "static/media/login-screen.eb92cbc6.svg";
export { ForwardRef as ReactComponent };